<template>
  <div>
    <chartjs-pie-card
      v-if="dataIsNotEmpty"
      :chart-data="chartData"
      :chart-options="chartOptions"
      style="/*min-height:475px*/"
    >
      <template slot="header">
        <div class="d-flex">
          <div class="card-title diligencePieChartTitle">Referrers</div>
          <div
            style="margin-left: 5px; margin-top: auto;margin-bottom: auto;"
            v-tooltip.top-end="toolTipInfo"
          >
            <img src="static/img/graphInfo.svg" class />
          </div>
        </div>
      </template>
    </chartjs-pie-card>
  </div>
</template>
<script>
import { vals, formatCurrency, subsetBackground } from "../../../util";
import { ChartjsPieCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
export default {
  name: "pie-referrer-chart-card",
  components: {
    [ChartjsPieCard.name]: ChartjsPieCard
  },
  props: {
    cutoutPercentage: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      dataIsEmpty: true,
      datasets: [],
      labels: [],
      textCenterLabel: [],
      totalCompanies: 0
    };
  },
  computed: {
    ...mapGetters("referrer", ["getReffersChartData"]),
    ...mapGetters("referrer", ["getReffersLength"]),
    ...mapGetters("portfolio", ["portfolioAll"]),
    chartData() {
      const self = this;
      let data = {
        labels: _.flatten(self.computedLabels),
        datasets: self.computedDataset
      };
      return data;
    },
    chartOptions() {
      const self = this;
      // let d = self.chartData
      let options = {
        cutoutPercentage: this.cutoutPercentage,
        plugins: {
          doughnutlabel: {
            labels: this.textCenterLabel
          }
        },
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function(toolTipItem, data) {
              if (!data.datasets[toolTipItem.datasetIndex].ucid) {
                let tooltip =
                  data.datasets[toolTipItem.datasetIndex].header_label[
                    toolTipItem.index
                  ] || "";
                return tooltip.charAt(0).toUpperCase() + tooltip.slice(1);
              }
              let headerTooltip =
                data.datasets[toolTipItem.datasetIndex].header_label[
                  toolTipItem.index
                ] || "";
              return (
                headerTooltip.charAt(0).toUpperCase() + headerTooltip.slice(1)
              );
            },
            footer: function(toolTips, data) {
              let toolTipItem = toolTips[0];
              if (!data.datasets[toolTipItem.datasetIndex].ucid) {
                let header_label =
                  data.datasets[toolTipItem.datasetIndex].header_label[
                    toolTipItem.index
                  ];
                let InvestedLength =
                  self.getReffersChartData.groupByData[header_label] &&
                  self.getReffersChartData.groupByData[header_label].length >
                    0 &&
                  self.getReffersChartData.groupByData[header_label][0]
                    .investData
                    ? self.getReffersChartData.groupByData[header_label][0]
                        .investData.length
                    : 0;
                let ReferredLength =
                  self.getReffersChartData.groupByData[header_label] &&
                  self.getReffersChartData.groupByData[header_label].length >
                    0 &&
                  self.getReffersChartData.groupByData[header_label][0]
                    .diligenceData
                    ? self.getReffersChartData.groupByData[header_label][0]
                        .diligenceData.length
                    : 0;
                return `Referred Over Time - ${InvestedLength +
                  ReferredLength}`;
              }
              //   let value =
              //     data.datasets[toolTipItem.datasetIndex].data_value[
              //       toolTipItem.index
              //     ] || 0;
              //   return value > 1 ? `${value} Companies` : `${value} Company`;
            }
          }
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false
        },
        onClick: function(unused, toolTips) {
          let toolTipItem = toolTips[0];
          if (!_.isNil(toolTipItem)) {
            if (toolTipItem._datasetIndex === 0) {
              // only 'drill-down' if it is a primary value
              let data = toolTipItem._chart.data;
              let propertyValue =
                data.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              self.addDatasetForProperty(propertyValue, toolTipItem._index);
              let referredOverTimeData =
                data.datasets[toolTipItem._datasetIndex].data_value[
                  toolTipItem._index
                ];
              let obj = {
                text:
                  propertyValue.charAt(0).toUpperCase() +
                  propertyValue.slice(1),
                font: {
                  size: "12",
                  family: "custom-helvetica-medium,roboto"
                },
                color: "#050505"
              };
              let textObj = {
                text: `Referred Over Time`,
                font: {
                  size: "12",
                  family: "custom-helvetica-medium,roboto"
                },
                color: "#050505"
              };
              let dataObj = {
                text: referredOverTimeData,
                font: {
                  size: "25",
                  family: "custom-helvetica-medium,roboto"
                },
                color: "#050505"
              };
              self.textCenterLabel[0] = obj;
              self.textCenterLabel[1] = textObj;
              self.textCenterLabel[2] = dataObj;
            } else if (toolTipItem._datasetIndex === 1) {
              // second tier
              let drillData = toolTipItem._chart.data;
              let drillPropertyValue =
                drillData.datasets[toolTipItem._datasetIndex].header_label[
                  toolTipItem._index
                ];
              let actualCompany = drillData.datasets[
                toolTipItem._datasetIndex
              ].ucid.find(item => {
                if (item.name == drillPropertyValue) {
                  return item;
                }
              });
              if (actualCompany) {
                let account_id = self.$route.params.account_id;
                let workspace_id = self.$route.params.workspace_id;
                let ucid = actualCompany.ucid;
                self.$store.commit("temp/currentCompany", ucid);
                self.$router.push(
                  `/${account_id}/${workspace_id}/companyProfile/${ucid}`
                );
              }
            }
          }
        }
      };
      return options;
    },
    computedDataset() {
      return this.datasets;
    },
    computedLabels() {
      return this.labels;
    },
    dataIsNotEmpty() {
      return this.getReffersLength > 0;
    },
    toolTipInfo() {
      return "Shows the number of companies referred over time by each referrer. Selecting a referrer shows the companies referred, invested, or passed by you in the inner circle.";
    }
  },
  methods: {
    createPrimaryDataset() {
      const self = this;
      // only do check if there is data (and it is local)
      if (self.getReffersLength < 1) return;
      self.labels = [];
      self.datasets = [];
      self.labels.push(self.getReffersChartData.labels);
      // create background colors...
      let bgColors = _.concat(
        vals.LEGEND.BACKGROUND_COLORS_1,
        vals.LEGEND.BACKGROUND_COLORS_2
      );
      self.datasets.push({
        header_label: self.getReffersChartData.labels,
        data: self.getReffersChartData["value_p"],
        data_value: self.getReffersChartData["value"],
        backgroundColor: bgColors
      });
      self.datasets[0].data_value.map(item => {
        if (item) {
          self.totalCompanies += Number(item);
        }
      });
      let centerTextObj = {
        text: `Referred Over Time`,
        font: {
          size: "12",
          family: "custom-helvetica-medium,roboto"
        },
        color: "#050505"
      };
      let centerDataObj = {
        text: self.totalCompanies,
        font: {
          size: "25",
          family: "custom-helvetica-medium,roboto"
        },
        color: "#050505"
      };
      self.textCenterLabel[0] = centerTextObj;
      self.textCenterLabel[1] = centerDataObj;
    },
    addDatasetForProperty(value, index) {
      const self = this;
      let values = self.getReffersChartData.groupByData[value];
      let finalObj = {
        value: [],
        value_p: [],
        names: [],
        header_label: [],
        ucid: []
      };
      let totalLength = 0;
      if (
        values.length > 0 &&
        values[0].investData &&
        values[0].investData.length > 0
      ) {
        totalLength =
          values[0].diligenceData && values[0].diligenceData.length > 0
            ? values[0].investData.length + values[0].diligenceData.length
            : values[0].investData.length;
        values[0].investData.map(item => {
          finalObj.value.push(1);
          finalObj.value_p.push(((1 / totalLength) * 100).toFixed(2));
          if (item.entity_id && item.entity_id.portfolio_item) {
            let companyObject = self.portfolioAll.find(company => {
              if (company._id == item.entity_id.portfolio_item) {
                finalObj.names.push(company.name);
                finalObj.ucid.push({
                  name: `${value}/Invested/${company.name}`,
                  ucid: company.ucid
                });
                finalObj.header_label.push(`${value}/Invested/${company.name}`);
                return company;
              }
            });
          }
        });
      }
      if (
        values.length > 0 &&
        values[0].diligenceData &&
        values[0].diligenceData.length > 0
      ) {
        totalLength =
          values[0].investData && values[0].investData.length > 0
            ? values[0].investData.length + values[0].diligenceData.length
            : values[0].diligenceData.length;
        values[0].diligenceData.map(item => {
          finalObj.value.push(1);
          finalObj.value_p.push(((1 / totalLength) * 100).toFixed(2));
          finalObj.names.push(item.entity_id.name);
          if (
            item.entity_id &&
            item.entity_id.rejectedNotes &&
            item.entity_id.rejectedNotes.length > 0
          ) {
            finalObj.ucid.push({
              name: `${value}/Passed/${item.entity_id.name}`,
              ucid: item.entity_id.ucid
            });
            finalObj.header_label.push(
              `${value}/Passed/${item.entity_id.name}`
            );
          } else {
            finalObj.ucid.push({
              name: `${value}/Referred/${item.entity_id.name}`,
              ucid: item.entity_id.ucid
            });
            finalObj.header_label.push(
              `${value}/Referred/${item.entity_id.name}`
            );
          }
        });
      }
      if (index > 9) index = index - 10;
      let bgColors = _.concat(subsetBackground(index), subsetBackground(index));
      if (totalLength <= bgColors.length) {
        // we want 'other' to be grey (default color) - remove colors so that other is 'empty'
        bgColors = _.slice(bgColors, 0, totalLength - 1);
      }
      // create the dataset...
      let dataset = {
        header_label: finalObj.header_label,
        data: finalObj.value_p,
        data_value: finalObj.value,
        backgroundColor: bgColors,
        ucid: finalObj.ucid
      };
      // if there is already a second dataset, remove it
      if (self.datasets.length > 1)
        self.datasets = _.slice(self.datasets, 0, 1);
      // add new one
      self.datasets.push(dataset);
      self.datasets = _.without(self.datasets, undefined, null);
    }
  },
  mounted() {
    this.createPrimaryDataset();
    //this.diligenceData = this.$store.getters["charts/diligenceChart"];
    // this.$store.dispatch("referrer/getReffers").then(data => {
    //   this.$store.getters["referrer/getReffersChartData"];
    //   this.$store.getters["referrer/getReffersLength"];
    //   if (this.getReffersLength > 0) {
    //     this.createPrimaryDataset();
    //   }
    //   this.$store.getters["portfolio/portfolioAll"];
    // });
  },
  watch: {
    getReffersLength: {
      handler(newData) {
        // updated portfolio, run update
        if (newData > 0) this.createPrimaryDataset();
      }
    }
  }
};
</script>